import { useParams, useNavigate } from 'react-router-dom'
import { ChevronLeft } from 'lucide-react'

export default function TermsPage() {
  const { slug } = useParams()
  const navigate = useNavigate()

  return (
    <div className="min-h-dvh bg-white">
      {/* Header */}
      <div className="sticky top-0 bg-white border-b border-gray-200 px-4 py-3 flex items-center gap-3 z-10">
        <button onClick={() => navigate(-1)} className="p-1 rounded-lg hover:bg-gray-100">
          <ChevronLeft size={20} className="text-gray-600" />
        </button>
        <h1 className="text-base font-semibold text-gray-900">Termos de Uso</h1>
      </div>

      {/* Conteúdo */}
      <div className="max-w-2xl mx-auto px-6 py-8 prose prose-sm text-gray-700">
        <h2 className="text-lg font-bold text-gray-900">Termos de Uso e Diretrizes da Comunidade</h2>
        <p className="text-xs text-gray-400 mb-6">Última atualização: Abril de 2026</p>

        <h3 className="text-sm font-semibold text-gray-900 mt-6 mb-2">1. Aceitação dos Termos</h3>
        <p className="text-sm leading-relaxed">
          Ao acessar e utilizar esta comunidade, você concorda com estes Termos de Uso e com nossas Diretrizes da Comunidade.
          Caso não concorde, não utilize a plataforma.
        </p>

        <h3 className="text-sm font-semibold text-gray-900 mt-6 mb-2">2. Conduta do Usuário</h3>
        <p className="text-sm leading-relaxed">Ao utilizar a comunidade, você se compromete a:</p>
        <ul className="text-sm space-y-1 mt-2">
          <li>Tratar todos os membros com respeito e cordialidade;</li>
          <li>Não publicar conteúdo ofensivo, discriminatório, difamatório ou que incite violência;</li>
          <li>Não praticar assédio, bullying ou intimidação contra outros membros;</li>
          <li>Não enviar spam, publicidade não autorizada ou conteúdo repetitivo;</li>
          <li>Não compartilhar conteúdo ilegal, pornográfico ou que viole direitos de terceiros;</li>
          <li>Não se passar por outra pessoa ou criar identidades falsas;</li>
          <li>Respeitar a privacidade dos demais membros.</li>
        </ul>

        <h3 className="text-sm font-semibold text-gray-900 mt-6 mb-2">3. Conteúdo Proibido</h3>
        <p className="text-sm leading-relaxed">É estritamente proibido publicar:</p>
        <ul className="text-sm space-y-1 mt-2">
          <li>Discurso de ódio baseado em raça, etnia, religião, gênero, orientação sexual ou deficiência;</li>
          <li>Ameaças de violência ou conteúdo que promova autolesão;</li>
          <li>Material sexualmente explícito ou pornográfico;</li>
          <li>Informações pessoais de terceiros sem consentimento;</li>
          <li>Conteúdo que viole leis aplicáveis.</li>
        </ul>

        <h3 className="text-sm font-semibold text-gray-900 mt-6 mb-2">4. Denúncias e Moderação</h3>
        <p className="text-sm leading-relaxed">
          Todos os membros podem denunciar conteúdo ofensivo e bloquear usuários abusivos diretamente pelo aplicativo.
          Denúncias são revisadas pela equipe de moderação em até 24 horas. Conteúdo que viole estas diretrizes será removido.
        </p>

        <h3 className="text-sm font-semibold text-gray-900 mt-6 mb-2">5. Consequências</h3>
        <p className="text-sm leading-relaxed">
          O descumprimento destas diretrizes pode resultar em:
        </p>
        <ul className="text-sm space-y-1 mt-2">
          <li>Remoção do conteúdo ofensivo;</li>
          <li>Suspensão temporária da conta;</li>
          <li>Banimento permanente da comunidade.</li>
        </ul>

        <h3 className="text-sm font-semibold text-gray-900 mt-6 mb-2">6. Bloqueio de Usuários</h3>
        <p className="text-sm leading-relaxed">
          Você pode bloquear qualquer usuário a qualquer momento. Ao bloquear um usuário, as mensagens dessa
          pessoa não serão mais exibidas para você. Você pode gerenciar seus bloqueios na página de perfil.
        </p>

        <h3 className="text-sm font-semibold text-gray-900 mt-6 mb-2">7. Privacidade</h3>
        <p className="text-sm leading-relaxed">
          Suas informações pessoais são tratadas de acordo com a Lei Geral de Proteção de Dados (LGPD).
          Não compartilhamos seus dados com terceiros sem seu consentimento.
        </p>

        <h3 className="text-sm font-semibold text-gray-900 mt-6 mb-2">8. Alterações nos Termos</h3>
        <p className="text-sm leading-relaxed">
          Estes termos podem ser atualizados periodicamente. Ao continuar utilizando a plataforma após
          alterações, você concorda com os novos termos.
        </p>

        <h3 className="text-sm font-semibold text-gray-900 mt-6 mb-2">9. Contato</h3>
        <p className="text-sm leading-relaxed">
          Em caso de dúvidas sobre estes termos ou para denúncias urgentes, entre em contato pelo e-mail:
          suporte@sispoli.com.br
        </p>
      </div>
    </div>
  )
}
